import { IconButton as MuiIconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const IconButton = styled(MuiIconButton)(({ theme }) => ({
  position: 'absolute',
  right: -14,
  bottom: 88,
  width: 28,
  height: 28,
  zIndex: theme.zIndex.drawer,
  backgroundColor: theme.palette.blue.dark,
}));
